"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RevenueIntegration() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "25%",
    label: "average revenue lift",
    align: "left"
  }, {
    value: "150+",
    label: "hotels optimized",
    align: "right"
  }, {
    value: "100%",
    label: "data-driven strategy",
    align: "left"
  }];
  return <section data-section-id="2138" id="revenueintegrationcta" className="relative overflow-hidden bg-slate-50 text-slate-900 py-24 md:py-44 px-5 sm:px-8 lg:px-18">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute font-default select-none leading-none" style={{
      fontSize: "clamp(12rem, 22vw, 22rem)",
      fontWeight: 700,
      color: "hsl(222 47% 7% / 0.03)",
      top: "8%",
      left: "2%",
      letterSpacing: "-0.05em"
    }}>
        01
      </div>

      <div className="relative mx-auto max-w-[1440px] grid grid-cols-12 gap-6 md:gap-8 items-start">
        {}
        <div ref={leftRef} className="col-span-12 lg:col-span-5 order-2 lg:order-1 flex flex-col" style={{
        opacity: leftVisible ? 1 : 0,
        transform: leftVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1), transform 640ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          {}
          <div className="flex items-center gap-3 mb-8">
            <span aria-hidden="true" className="inline-block h-px w-6 bg-slate-900" />
            <span className="font-default uppercase" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            fontWeight: 600,
            letterSpacing: "0.18em",
            lineHeight: 1,
            color: "hsl(222 47% 7%)"
          }}>
              § REVENUE STRATEGY — HOTELREVBABA
            </span>
          </div>

          {}
          <h2 className="font-default mb-8 text-slate-900" style={{
          fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)",
          fontWeight: 700,
          lineHeight: 1.02,
          letterSpacing: "-0.02em"
        }}>
            Maximize your hotel’s{" "}
            <span className="italic text-amber-600" style={{
            fontWeight: 400
          }}>
              revenue
            </span>{" "}
            with data-driven strategies.
          </h2>

          {}
          <p className="mb-12 max-w-xl text-slate-700" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
          fontWeight: 400,
          lineHeight: 1.6,
          letterSpacing: "-0.005em"
        }}>
            Sunil Singh delivers expert revenue management consulting, leveraging advanced OTA strategies and hospitality tech stacks to solve demand challenges and drive direct booking growth for your property.
          </p>

          {}
          <div className="flex flex-col gap-7 mb-12">
            {stats.map((stat, i) => <div key={i} data-index={i} className={`flex items-center gap-5 ${stat.align === "right" ? "flex-row-reverse text-right" : ""}`}>
                <div className="relative flex items-center flex-1 min-w-0">
                  <span className="h-px flex-1 bg-slate-300" />
                  <span aria-hidden="true" className="block h-1.5 w-1.5 rounded-lg ml-0 bg-amber-600" />
                </div>
                <div className="flex items-baseline gap-3 shrink-0">
                  <span className="font-default" style={{
                fontSize: "clamp(1.75rem, 2.5vw, 2.5rem)",
                fontWeight: 700,
                letterSpacing: "-0.02em",
                color: "hsl(222 47% 7%)",
                lineHeight: 1
              }}>
                    {stat.value}
                  </span>
                  <span className="font-default uppercase" style={{
                fontSize: "0.6875rem",
                letterSpacing: "0.18em",
                color: "hsl(215 16% 47%)"
              }}>
                    / {stat.label}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/ContactPage">
              <Button className="rounded-lg px-8 py-6 h-auto font-default uppercase transition-all duration-[220ms] ease-out hover:-translate-y-0.5 bg-amber-600 text-white">
                Book a Consultation
              </Button>
            </Link>
            <Link to="#">
              <Button variant="outline" className="rounded-lg px-8 py-6 h-auto font-default uppercase bg-transparent transition-colors duration-[220ms] ease-out border-slate-900 text-slate-900">
                View Services
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={rightRef} className="col-span-12 lg:col-span-7 order-1 lg:order-2" style={{
        opacity: rightVisible ? 1 : 0,
        transform: rightVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms, transform 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
      }}>
          <div className="relative w-full shadow-lg rounded-lg overflow-hidden" style={{
          aspectRatio: "16 / 10"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_management_consulting.png" alt="Sunil Singh consulting with hotel management team on revenue strategy" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div className="absolute bottom-4 left-4 z-10 font-default uppercase bg-slate-900/80 backdrop-blur-sm px-3 py-1 text-white" style={{
            fontSize: "0.6875rem",
            letterSpacing: "0.08em",
            lineHeight: 1.2
          }}>
              Expert Revenue Management — HotelRevBaBa
            </div>
          </div>
        </div>
      </div>
    </section>;
}